import React, { Component, Fragment } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as ReportsActions,
  Selectors as ReportSelectors,
} from "store/ducks/reports";

import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Filters, AnalyticFilter } from "./components";

const INITIAL_STATE = {
  order_id: "",
  external_order_id: "",
  date_start: null,
  date_end: null,
};

class Webpremios extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "/reports" },
      { name: "Web Prêmios", to: "" },
    ],
    filter: INITIAL_STATE,
  };

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (
      oldState.filter.date_start !== filter.date_start ||
      oldState.filter.date_end !== filter.date_end
    ) {
      const date_formatted = filter.date_start
        ? `${
            filter.date_start !== null
              ? moment(filter.date_start).format("DD/MM/YYYY")
              : ""
          } ${filter.date_end !== null ? "-" : ""} ${
            filter.date_end !== null
              ? moment(filter.date_end).format("DD/MM/YYYY")
              : ""
          }`
        : "";

      this.setState({ filter: { ...filter, date_formatted } });
    }

    if (oldState.filter.stores !== filter.stores) {
      const stores_formatted = filter.stores
        .map((store) => store.label)
        .join(", ");

      this.setState({ filter: { ...filter, stores_formatted } });
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;

    this.setState({ filter: { ...filter, [name]: value } });
  };

  handleCleanFilter = async (e) => {
    e.preventDefault();

    this.setState({ filter: INITIAL_STATE });
  };

  handleSubmitFilter = async () => {
    const { getReportWebpremiosRequest } = this.props;

    getReportWebpremiosRequest(this.state.filter);
  };

  handleExport = () => {
    const { filter } = this.state;
    const { exportReportWebpremiosRequest } = this.props;

    exportReportWebpremiosRequest(filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { reports } = this.props;

    return (
      <Page className="page-reports page-reports-webpremios">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Relatório Contábil (Web prêmios)</Page.Title>

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
            onSubmit={this.handleSubmitFilter}
          />
        </header>

        <Panel className="panel-list">
          {!reports.data.length && reports.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {reports.loading && <Loading type="table" size="x-large" />}

              <h5>Relatório Contábil (Web prêmios)</h5>

              <table className="contact-table table table-curved">
                <thead>
                  <tr>
                    <th>N° do Pedido</th>
                    <th>Pedido Principal</th>
                    <th>N° do Regaste Interno</th>
                    <th>Data Criação</th>
                    <th>Valor do Produto</th>
                    <th>Devolução</th>
                    <th>Valor em Reais</th>
                    <th>Status do Pedido</th>
                  </tr>
                </thead>

                <tbody>
                  {!!reports.data.length &&
                    reports.data.map((report) => (
                      <tr
                        key={String(
                          `webpremios-${report.id}-${
                            report.externalId
                          }-${Math.random()}${
                            report.devolution ? "devolution" : "pontuation"
                          }`
                        )}
                      >
                        <td>{report.external_id}</td>
                        <td>{report.parent_order_id}</td>
                        <td>{report.id}</td>
                        <td>{report.created_at}</td>
                        <td>{report.points}</td>
                        <td>{report.devolution}</td>
                        <td>{report.total}</td>
                        <td>{report.status}</td>
                      </tr>
                    ))}
                </tbody>
              </table>

              <AnalyticFilter
                data={filter}
                onChange={this.handleChangeFilter}
                onClean={this.handleCleanFilter}
                onSubmit={this.handleSubmitFilter}
              />

              <button
                className="button-submit"
                onClick={this.handleExport}
                disabled={reports.export.loading}
              >
                {reports.export.loading
                  ? "Gerando arquivo ..."
                  : "Exportar Planilha"}
              </button>
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  reports: {
    ...state.reports.webpremios,
    data: ReportSelectors.webpremios(state.reports.webpremios.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(ReportsActions, dispatch);

export default connect(mapState, mapActions)(Webpremios);
